import { useMemo } from 'react';

import { Pointer } from './types';

export const MAX_ESTATES_COUNT = 99;

export const useFormattedEstatesCount = (pointer: Pointer) => {
  const estatesCount = useMemo(
    () => Math.min(pointer.estatesCount, MAX_ESTATES_COUNT),
    [pointer.estatesCount],
  );

  const hasMultipleEstates = useMemo(() => estatesCount > 1, [estatesCount]);

  const formattedEstatesCount = useMemo(
    () =>
      hasMultipleEstates
        ? estatesCount === MAX_ESTATES_COUNT
          ? estatesCount + '+'
          : estatesCount
        : '',
    [estatesCount],
  );

  return {
    hasMultipleEstates,
    estatesCount,
    formattedEstatesCount,
  };
};
